import React, { useEffect, lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import CookieConsent from './components/CookieConsent';

// Pagine caricate eagerly (critiche per la Home)
import Home from './pages/Home';

// Tutte le altre pagine lazy-loaded (riducono il bundle iniziale)
const ChiSiamo       = lazy(() => import('./pages/ChiSiamo'));
const Contatti       = lazy(() => import('./pages/Contatti'));
const SoluzioniIndex = lazy(() => import('./pages/Soluzioni/Index'));
const Vista          = lazy(() => import('./pages/Soluzioni/Vista'));
const Sole           = lazy(() => import('./pages/Soluzioni/Sole'));
const Lenti          = lazy(() => import('./pages/Soluzioni/Lenti'));
const BlogIndex      = lazy(() => import('./pages/Blog/Index'));
const BlogArticle    = lazy(() => import('./pages/Blog/[slug]'));
const Privacy        = lazy(() => import('./pages/Privacy'));
const Cookie         = lazy(() => import('./pages/Cookie'));
const Offerte        = lazy(() => import('./pages/Offerte'));
const Stampa3D       = lazy(() => import('./pages/Soluzioni/Stampa3D'));
const Anima          = lazy(() => import('./pages/Soluzioni/Anima'));
const CatalogoBragi  = lazy(() => import('./pages/CatalogoBragi'));
const AdultCollection = lazy(() => import('./pages/CatalogoBragi/AdultCollection'));
const BovSeries      = lazy(() => import('./pages/CatalogoBragi/BovSeries'));
const Kids           = lazy(() => import('./pages/CatalogoBragi/Kids'));
const SunglassClip   = lazy(() => import('./pages/CatalogoBragi/SunglassClip'));
const Catalogo       = lazy(() => import('./pages/Catalogo'));
const BrandPage      = lazy(() => import('./pages/Catalogo/BrandPage'));

export default function App() {
  // Protezione immagini
  useEffect(() => {
    // Disabilita click destro sulle immagini
    const handleContextMenu = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        return false;
      }
    };

    // Disabilita drag delle immagini
    const handleDragStart = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
    };
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navigation />
      <Suspense fallback={null}>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chi-siamo/" element={<ChiSiamo />} />
        <Route path="/contatti/" element={<Contatti />} />
        <Route path="/soluzioni/" element={<SoluzioniIndex />} />
        <Route path="/occhiali/" element={<SoluzioniIndex />} />
        <Route path="/occhiali-da-vista/" element={<Vista />} />
        <Route path="/occhiali-da-sole/" element={<Sole />} />
        <Route path="/lenti-a-contatto/" element={<Lenti />} />
        <Route path="/blog/" element={<BlogIndex />} />
        <Route path="/blog/:slug/" element={<BlogArticle />} />
        <Route path="/privacy/" element={<Privacy />} />
        <Route path="/cookie/" element={<Cookie />} />
        <Route path="/offerte/" element={<Offerte />} />
        <Route path="/montature-stampate-3d/" element={<Stampa3D />} />
        <Route path="/lenti-progressive-personalizzate/" element={<Anima />} />
        {/* Catalogo multi-brand */}
        <Route path="/catalogo/" element={<Catalogo />} />
        <Route path="/catalogo/:brand/" element={<BrandPage />} />

        {/* Redirect SEO: vecchi URL catalogo-bragi → nuovi URL */}
        <Route path="/catalogo-bragi/" element={<Navigate replace to="/catalogo/bragi/" />} />
        <Route path="/catalogo-bragi/adult-collection/" element={<Navigate replace to="/catalogo/bragi/" />} />
        <Route path="/catalogo-bragi/bov-series/" element={<Navigate replace to="/catalogo/bragi/" />} />
        <Route path="/catalogo-bragi/kids/" element={<Navigate replace to="/catalogo/bragi/" />} />
        <Route path="/catalogo-bragi/sunglass-clip/" element={<Navigate replace to="/catalogo/bragi/" />} />
        </Routes>
      </Suspense>
      <Footer />
      <WhatsAppButton />
      <CookieConsent />
    </>
  );
}
